/// Pure rules for the radar's map labels, kept free of Pixi so they test
/// without a canvas. Ported from iOS `MapLabelScalePolicy` and
/// `FieldElevationLabel` (FlatoutATC/Models/).

/// The counter-scale that keeps a map label at its authored size on screen
/// when the player zooms out (iOS BACKLOG #133). Floored at 1, so zooming in
/// past native never shrinks a label below its authored size. A pixi-viewport
/// scale is the inverse of a SpriteKit camera scale (bigger = closer), hence
/// 1 / scale where iOS uses the camera scale itself.
export function mapLabelScale(viewportScale: number): number {
  if (!Number.isFinite(viewportScale) || viewportScale <= 0) return 1
  return Math.max(1, 1 / viewportScale)
}

/// Fields at or above this elevation show it under their name (iOS #150 a),
/// so sea-level maps gain no clutter.
export const FIELD_ELEVATION_MIN_FT = 1000

/// The dimmer line under a high field's name, e.g. "9334 ft": no grouping
/// separator, as charts print it. Null below 1,000 ft or with no elevation.
/// Judged on the raw value, so 999.9 does not round up into a label.
export function fieldElevationText(elevationFt: number | undefined): string | null {
  if (elevationFt === undefined || !Number.isFinite(elevationFt)) return null
  if (elevationFt < FIELD_ELEVATION_MIN_FT) return null
  return `${Math.round(elevationFt)} ft`
}
